import { apiGenerator } from '../../../framework/apis/apiGenerator';
import { env } from '../../../framework/utils/EnvUtils';
import { AssignedMatterSearchParam } from '../../models/gen/assignedMatterSearchParam';
import { AssignedMatterSearchResult } from '../../models/gen/assignedMatterSearchResult';
import { useGenericMutation } from '../../utils/ReactQueryUtils';
import { queryOptions } from './base';

export const ASSIGNED_MATTER_CONTEXT_NAMES = {
  POST_ASSIGNED_MATTER_SEARCH: 'searchAssignedMatter',
} as const;

const apis = apiGenerator();

/**
 * POST `/assigned-matter/search`
 *
 * @param param -
 * @returns
 */
export const usePostAssignedMatterSearch = () =>
  useGenericMutation(async (param: AssignedMatterSearchParam) =>
    apis.post<AssignedMatterSearchParam, AssignedMatterSearchResult>(
      `${env.BASE_API_ENDPOINT}/assigned-matter/search`,
      { ...queryOptions, data: param }
    )
  );
